import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative overflow-hidden min-h-[85vh] flex items-center">
      {/* Floating Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(22)].map((_, i) => (
          <div
            key={i}
            className={`absolute rounded-full animate-pulse ${i % 3 === 0 ? 'w-1 h-1 bg-cyan-400/50' : i % 3 === 1 ? 'w-1 h-1 bg-purple-500/50' : 'w-0.5 h-0.5 bg-white/40'}`}
            style={{
              left: `${(i * 5.3 + 2) % 100}%`,
              top: `${(i * 7.1 + 3) % 100}%`,
              animationDelay: `${(i * 0.3) % 3}s`,
              animationDuration: `${2 + (i * 0.15) % 3}s`
            }}
          />
        ))}
      </div>

      {/* Ambient glow blobs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600/8 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-600/6 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-6 pb-12 w-full">
        {/* Top badge */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 border border-white/20 rounded-full text-xs uppercase tracking-widest text-white/80 backdrop-blur-sm bg-black/20">
            <span className="inline-block w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></span>
            Tech Reviews &amp; Buying Guides
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* ── Left Column ── */}
          <div className="space-y-8">
            <h1 className="text-3xl sm:text-5xl lg:text-7xl font-bold leading-tight">
              <div className="text-white">THE BEST TECH FOR</div>
              <div className="bg-gradient-to-r from-purple-400 via-cyan-400 to-emerald-400 bg-clip-text text-transparent">
                WORK, GAMING &amp; STREAMING
              </div>
            </h1>

            <p className="text-base sm:text-lg text-gray-400 max-w-xl leading-relaxed">
              Research-backed recommendations to upgrade your setup without overspending. No fluff, no bias. Just the gear that&apos;s actually worth buying.
            </p>

            {/* Single CTA */}
            <div className="flex flex-wrap gap-4">
              <Link
                to="/articles"
                className="px-8 py-4 bg-gradient-to-r from-purple-600 to-cyan-600 text-white rounded-lg font-bold hover:shadow-2xl hover:shadow-purple-500/50 transition-all duration-300 transform hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                Browse Top Picks
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <p className="text-sm text-gray-500 italic">
              1,000+ tech products researched and compared.
            </p>
          </div>

          {/* Right Column - Image */}
          <div className="relative hidden lg:block">
            <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 to-cyan-600/20 rounded-2xl blur-3xl"></div>
            <img
              src="https://public.readdy.ai/ai/img_res/230420cc432074bffa991ef6e1574251.jpg"
              alt="Premium Gaming Setup"
              className="relative rounded-2xl object-cover w-full h-[600px] object-top"
            />
            {/* Floating stat pills */}
            <div className="absolute top-6 right-6 flex flex-col gap-2">
              <div className="px-3 py-1.5 bg-black/70 border border-purple-500/30 rounded-full backdrop-blur-sm text-xs text-purple-400 font-semibold whitespace-nowrap">
                <i className="ri-star-fill mr-1 text-amber-400"></i> 1,000+ Products Reviewed
              </div>
              <div className="px-3 py-1.5 bg-black/70 border border-cyan-500/30 rounded-full backdrop-blur-sm text-xs text-cyan-400 font-semibold whitespace-nowrap">
                <i className="ri-shield-check-fill mr-1 text-emerald-400"></i> Independent Reviews
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
